import React from "react";
import VideoContainer from "./VideoContainer/VideoContainer"; 
const Home=()=>{
    return <>
       <VideoContainer />
    </>
}
export default Home;